import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";

import builder from "../../common/store/builder";
import panel from "./panel.js";

const reducer = { panel: panel.reducer, builder: builder.reducer };

let store = null;
export default function GetStore(preloadedState = {}) {
    if (!store || !__isBrowser__) {
        store = configureStore({
            reducer,
            preloadedState,
            middleware: gdm => gdm().concat(thunk),
        });
    }

    return store;
}
